var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSandglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14H10.5",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 2.75H5.25C4.8 2.75 4.5 3.05 4.5 3.5V5.3C4.5 5.6 4.575 5.9 4.8 6.2L7.2 9.5L4.8 12.8C4.65 13.025 4.5 13.4 4.5 13.7V15.5C4.5 15.95 4.8 16.25 5.25 16.25H12.75C13.2 16.25 13.5 15.95 13.5 15.5V13.775C13.5 13.475 13.425 13.1 13.2 12.875L10.65 9.575L13.2 6.275C13.425 5.975 13.5 5.675 13.5 5.375V3.65C13.5 3.125 13.125 2.75 12.75 2.75Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandglass);
export default __webpack_public_path__ + "static/media/Sandglass.2b370112049109e6b38af2e9bbf3048a.svg";
export { ForwardRef as ReactComponent };